import { io, Socket } from "socket.io-client";

const SOCKET_URL =
  import.meta.env.MODE === "development"
    ? "http://localhost:3000"
    : import.meta.env.VITE_SOCKET_URL;

let socket: Socket | null = null;
let isListenersAttached = false;

export const getSocket = (userId: string | null): Socket => {
  if (!socket) {
    socket = io(SOCKET_URL, {
      query: { userId }, // Envia o ID no handshake
      transports: ["websocket"],
      reconnection: false, // sem servidor socket.io na API demo — evita flood de erros no console
    });

    // Adiciona os listeners de eventos apenas uma vez
    if (!isListenersAttached) {
      socket.on("connect", () => {
        console.log("🔌 WebSocket conectado:", socket?.id);
      });

      socket.on("disconnect", () => {
        console.log("❌ WebSocket desconectado");
      });

      isListenersAttached = true;
    }
  }

  return socket;
};

export const disconnectSocket = () => {
  if (socket) {
    socket.disconnect();
    socket = null;
  }
};
